import {Button} from '@wandb/components';
import React from 'react';
import {twMerge} from 'tailwind-merge';

// floating jump control shared by the dense (jump-to-bottom) and global
// (jump-to-top/current) log lists.
export const LogJumpButton: React.FC<{
  emphasis?: boolean;
  icon: React.ComponentProps<typeof Button>['startIcon'];
  label: string;
  onPress: () => void;
  position: 'top' | 'bottom';
}> = ({emphasis = false, icon, label, onPress, position}) => {
  return (
    <div
      className={twMerge(
        'pointer-events-none absolute left-1/2 z-10 -translate-x-1/2',
        position === 'top' ? 'top-12' : 'bottom-12'
      )}>
      <div className="pointer-events-auto rounded-md shadow-sm">
        <Button
          startIcon={icon}
          variant={emphasis ? 'primary' : 'secondary'}
          size="sm"
          onPress={onPress}>
          {label}
        </Button>
      </div>
    </div>
  );
};
